var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGoals = function SvgGoals(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18.335,
    height: 17.917,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1.248-1.248h20v20h-20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-.414-.414h18.331v18.331H-.414z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.859 2.543 15.55 4.328l-2.508 3.426-1.586 2.163-.101.68.66-.262 3.957-5.402c.7-.953 1.21-1.656 1.457-1.984a7.906 7.906 0 0 0-.223-.184 1.922 1.922 0 0 0-.347-.222Zm-1.977 1.289L16.34 1.84l.11-.14.175-.024a.75.75 0 0 1 .094-.008c.305 0 .691.203.996.445.32.25.586.582.613.805.004.02.007.041.008.062v.133l-.082.117-1.61 2.2-4.026 5.495-.07.098-.114.043-1.445.574-.672.266.105-.715.227-1.496.016-.098.062-.086 1.644-2.246 2.512-3.425v-.008Z",
    fill: "#333",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.937 0h11.46c.519 0 .938.42.938.937v4.305l-.836 1.14V.938a.105.105 0 0 0-.03-.07.105.105 0 0 0-.071-.031H.938a.105.105 0 0 0-.07.031.105.105 0 0 0-.032.07V16.98a.107.107 0 0 0 .101.105h9.305l2.257-2.254v-3.32l.29-.176.117-.109.43-.582v4.531l-.126.121-2.503 2.5-.293.121H.937A.937.937 0 0 1 0 16.98V.937C0 .42.42 0 .937 0Z",
    fill: "#333",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    fillRule: "nonzero",
    d: "M2.086 4.586h8.75v.832h-8.75zM2.086 7.086h8.75v.832h-8.75zM2.086 9.585h7.082v.832H2.086zM2.086 12.085h7.082v.832H2.086z"
  }))));
};
export default SvgGoals;